import { getCode } from 'iso-3166-1-alpha-2';
import { PassengersTypeEnum } from 'src/app/libs/data-access/models/enums/passengers.enum';

export namespace PaymentPageUtils {

    enum PassengersGenderEnum {
        MALE = 'm',
        FEMALE = 'f'
    }

    enum PassengersTitleEnum {
        MR = 'mr',
        MS = 'ms'
    }

    enum IdentityDocumentTypesEnum {
        PASSPORT = "passport"
    }

    export function buildFlightOrderRequestPayload(flightOffer: any, checkoutForm: any): any { //TODO: complete types
        const {
            id: selectedOffer,
            passengers: flightOfferPassengersArray,
            passenger_identity_documents_required: requiredPassengersIdentityDocuments,
            total_amount: amount,
            total_currency: currency
        } = flightOffer || {};
        const { email, phone, passengers } = checkoutForm || {};
        const { adults, children, infants } = passengers || {};
        const tempPassengersArray = adults.concat(children).concat(infants);
        const flightOrderPassengers = [];
        const infantPassengers = flightOfferPassengersArray.filter((passenger: any) => passenger.type === PassengersTypeEnum.INFANT);

        for (let i = 0; i < flightOfferPassengersArray.length; i++) {
            let passenger;
            if (infantPassengers.length > 0) {
                const infantPassengerId = infantPassengers.pop().id;
                passenger = createPassengerPayloadForFlightOrder(flightOfferPassengersArray[i].id, flightOfferPassengersArray[i].type, email, phone, tempPassengersArray[i], infantPassengerId);
            }
            else {
                passenger = createPassengerPayloadForFlightOrder(flightOfferPassengersArray[i].id, flightOfferPassengersArray[i].type, email, phone, tempPassengersArray[i]);
            }
            if (requiredPassengersIdentityDocuments) {
                flightOrderPassengers.push({ ...passenger, identity_documents: [{ ...createPassengerIdentityDocumentsInfoForFlightOrder(tempPassengersArray[i]) }] });
            }
            else {
                flightOrderPassengers.push(passenger);
            }
        }
        const requestQuery =
        {
            selected_offers: [selectedOffer],
            payments: [{ currency, amount }],
            passengers: flightOrderPassengers
        }

        return requestQuery;
    }

    function createPassengerPayloadForFlightOrder(id: string, type: string, email: string, phone: string, passenger: any, infantPassengerId?: string) {
        const passengerPayload = {
            type,
            id,
            email,
            title: ((passenger.gender === 'Male')) ? PassengersTitleEnum.MR : PassengersTitleEnum.MS,
            phone_number: phone,
            given_name: passenger.firstName,
            family_name: passenger.lastName,
            gender: ((passenger.gender === 'Male')) ? PassengersGenderEnum.MALE : PassengersGenderEnum.FEMALE,
            born_on: passenger.dateOfBirth.toISOString().split('T')[0],
        };
        if (infantPassengerId) {
            return { ...passengerPayload, infant_passenger_id: infantPassengerId };
        }
        return passengerPayload;
    }

    function createPassengerIdentityDocumentsInfoForFlightOrder(passenger: any) {
        return {
            expires_on: passenger.passportExpirationDate.toISOString().split('T')[0],
            type: IdentityDocumentTypesEnum.PASSPORT,
            unique_identifier: passenger.passportNumber,
            issuing_country_code: getCode(passenger.countryOfIssuance)
        }
    }
}